import React, { useState } from 'react';
import * as Constants from './constants';
import { getMonthNumber } from './utils';
import { DownloadMap } from './DownloadMap';
import { MapFilter } from './MapFilter';

export const DownloadMapContainer = ({
    sections,
    sectionNumber,
    rawData,
    isLoading,
    handleSectionChanged,
}) => {
    const years = rawData && rawData.length > 0
        ? Array.from(
            new Set(rawData.map(d => d.year))
        ).sort()
        : [new Date().getFullYear()];
    const [year, setYear] = useState(years[years.length - 1]);
    const selectedYear = years.includes(year) ? year : years[years.length - 1];
    const [startMonth, setStartMonth] = useState(1);
    const [endMonth, setEndMonth] = useState(12);
    const [mapType, setMapType] = useState(Constants.MAP_TYPE_US_REGIONS);

    if (isLoading) {
        return <p>Loading manufacturer data...</p>
    }

    if (!sections || sections.length === 0) {
        return "Please select a manufacturer with Product MasterSpec sections.";
    }

    return (
        <div>
            <MapFilter
                sections={sections}
                sectionNumber={sectionNumber}
                handleSectionChanged={handleSectionChanged}
                handleYearChanged={setYear}
                startMonth={startMonth}
                handleStartMonthChanged={(monthName) => setStartMonth(getMonthNumber(monthName))}
                endMonth={endMonth}
                handleEndMonthChanged={(monthName) => setEndMonth(getMonthNumber(monthName))}
                selectedMapType={mapType}
                handleMapTypeChanged={setMapType}
                years={years}
                year={selectedYear}
            />
            <div style={{ marginTop: 10 }} >
                <DownloadMap
                    mapType={mapType}
                    rawData={rawData}
                    sectionNumber={sectionNumber}
                    year={selectedYear}
                    startMonth={startMonth}
                    endMonth={endMonth}
                />
            </div>
        </div>
    )
}
